import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useState } from "react";
import YouTube from "react-youtube";
import { isNotUndefinedOrNull, isUndefined, TrustArcGroupId, trustArcGroupIsActive, videoTracking, windowOnLoadOrImmediate } from "../FunctionsCore";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import MediaVideoStyles from "./MediaVideoStyles.module.scss";
const styles = MediaVideoStyles;
const classCombiner = classCombinerFromPrefix("d29e73f064c73b05");
const onPlay = (yo) => {
    videoTracking(yo.target.videoTitle, "event7");
    yo.target.playVideo();
};
const onEnd = (yo) => {
    videoTracking(yo.target.videoTitle, "event8");
};
export const MediaVideoComponent = (props) => {
    const { fullwidthVideo = false, showMissingVideoIdWarning, thumbnailImage, videoId, videoTitle } = props;
    const [play, setPlay] = useState(false);
    const [userHasGivenMarketingConsent, setUserHasGivenMarketingConsent] = useState(false);
    useEffect(() => {
        windowOnLoadOrImmediate($(window), () => {
            try {
                if (isNotUndefinedOrNull(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupThree))) {
                    setUserHasGivenMarketingConsent(trustArcGroupIsActive(TrustArcGroupId.trustArcGroupThree));
                }
            }
            catch (er) {
                console.log("Video-error", er);
            }
        });
    }, []);
    return (isUndefined(videoId)
        ?
            (showMissingVideoIdWarning
                ? _jsx("h2", { children: "This component has not been configured with a YouTube video ID. This warning will not appear in production." })
                : _jsx(_Fragment, {}))
        :
            _jsx("div", Object.assign({ className: cx(classCombiner(styles, fullwidthVideo ? "fullWidthMediaVideoWrapper" : "mediaVideoWrapper")) }, { children: isNotUndefinedOrNull(thumbnailImage) && !play
                    ?
                        _jsxs(_Fragment, { children: [_jsx("div", { className: cx(classCombiner(styles, "thumbnailIcon")), onClick: () => setPlay(true) }), _jsx("div", { className: cx(classCombiner(styles, "thumbnail")), style: {
                                        "backgroundImage": `url(${thumbnailImage})`
                                    } }), _jsx("button", { className: cx(classCombiner(styles, "thumbnailButton")), onClick: () => setPlay(true), type: "button" })] })
                    :
                        (userHasGivenMarketingConsent
                            ?
                                _jsx(YouTube
                                // TODO videoWrapper
                                , { 
                                    // TODO videoWrapper
                                    className: cx("videoWrapper"), iframeClassName: cx(classCombiner(styles, "iframe")), onEnd: (yo) => onEnd(yo), onReady: (yo) => onPlay(yo), opts: {
                                        "playerVars": {
                                            "autoplay": 1,
                                            "wmode": "opaque",
                                        },
                                    }, videoId: videoId })
                            :
                                // eslint-disable-next-line react/iframe-missing-sandbox
                                _jsx("iframe", { allow: "autoplay;fullscreen", 
                                    // TODO ?
                                    // Does lazyload do anything?
                                    className: cx("lazyload", classCombiner(styles, "iframe")), frameBorder: "0", src: `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`, 
                                    // TODO Is this correct?
                                    title: videoTitle })) })));
};
const mediaVideo = (renderableData) => renderIdentifierGeneric(MediaVideoComponent, renderableData);
export { mediaVideo };
